import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";

interface SearchProposalsListViewItemProps {
  proposal: string;
  onProposalClick: (proposal: string) => void;
}

export const SearchProposalsListViewItem = ({
  proposal,
  onProposalClick,
}: SearchProposalsListViewItemProps) => {
  return (
    <FixaListViewItem
      title={proposal.toLocaleUpperCase()}
      inset
      size={"small"}
      key={proposal}
      onClick={() => onProposalClick(proposal)}
      control="navigational"
      controlIcon={null}
    />
  );
};
